// Centralize all process.env in this class. It helps us manage and know what env vars we are using currently.
import locator from '@/service-locator'

class Config {
  env = process.env.VUE_APP_ENV

  isDev = process.env.VUE_APP_ENV === 'development'

  isProduction = process.env.VUE_APP_ENV === 'production'

  isStaging = process.env.VUE_APP_ENV === 'staging'

  releaseVersion = process.env.VUE_APP_RELEASE_VERSION || 'unknown'

  zendeskKey = process.env.VUE_APP_ZENDESK_KEY || ''

  zendeskMetaBotLocaleMobileWeb =
    process.env.VUE_APP_ZENDESK_META_BOT_LOCALE || ''

  zendeskMetaContactPlatform =
    process.env.VUE_APP_ZENDESK_META_CONTACT_PLATFORM || ''

  zendeskMetaMerchantAuthenticatedStatus =
    process.env.VUE_APP_ZENDESK_META_MERCHANT_AUTHENTICATED_STATUS || ''

  zendeskMetaMerchantName = process.env.VUE_APP_ZENDESK_META_MERCHANT_NAME || ''

  zendeskMetaMerchantTier = process.env.VUE_APP_ZENDESK_META_MERCHANT_TIER || ''

  zendeskMetaMerchantEmail =
    process.env.VUE_APP_ZENDESK_META_MERCHANT_EMAIL || ''

  zendeskMetaMerchantId = process.env.VUE_APP_ZENDESK_META_MERCHANT_ID || ''

  zendeskMetaMerchantCode = process.env.VUE_APP_ZENDESK_META_MERCHANT_CODE || ''

  apiJerk = process.env.VUE_APP_JERK_API || ''

  defaultChatbotService = process.env.VUE_APP_DEFAULT_CHATBOT_SERVICE || ''

  isEnabledAdtechAds = [
    'production',
    'staging',
    'local',
    'dev5',
    'sandbox',
  ].includes(process.env.VUE_APP_ENV)

  guidesailKey =
    'ajpRPkBHLaLmAkgEvVV5LuuCqhkkhbyCUxfU8ySwT3Nh497DY63bfOuNalgLuD10'

  onboardingPageUrl = process.env.VUE_APP_ONBOARDING_PAGE_URL || ''

  googleMapsApiKey =
    process.env.VUE_APP_GOOGLE_MAPS_API_KEY ||
    'AIzaSyB4Y7YVZH1PCeXpZ6tpvM4kXa2fobq7AJk'

  statsigKey = process.env.VUE_APP_STATSIG_CLIENT_KEY || ''

  isEnabledFarahPromotionReview =
    process.env.VUE_APP_ADTECH_PROMOTION_REVIEW === 'true'

  farahPromotionReviewIds =
    process.env.VUE_APP_ADTECH_PROMOTION_REVIEW_IDS || ''

  partnerPageUrl = process.env.VUE_APP_PARTNER_PAGE_URL || ''

  gaMeasurementId = process.env.VUE_APP_GA4_ID || ''

  googleAdsId = process.env.VUE_APP_GOOGLE_ADS_ID || ''

  rudderStackWriteKey = process.env.VUE_APP_RUDDERSTACK_WRITE_KEY || ''

  rudderStackDataPlaneUrl = process.env.VUE_APP_RUDDERSTACK_DATA_PLANE_URL || ''
}

locator.config = new Config()

export default locator.config
